/**
 * Custom logger utility that only logs in development environments
 * Checks both NODE_ENV and the current URL to determine if in development
 */

// Check if we're in development based on environment variable or URL
const isDevelopment = (): boolean => {
  // Check if NODE_ENV is set to development
  const isDev = process.env.NODE_ENV === "development";

  // Check if we're on localhost or a development domain
  const isLocalhost =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      window.location.hostname.includes(".local") ||
      window.location.hostname.includes("dev-") ||
      window.location.hostname.includes(".dev"));

  return isDev || isLocalhost;
};

// Logger object with methods that only log in development
export const devLogger = {
  log: (...args: any[]): void => {
    if (isDevelopment()) {
      console.log("[DEV]", ...args);
    }
  },

  info: (...args: any[]): void => {
    if (isDevelopment()) {
      console.info("[DEV]", ...args);
    }
  },

  warn: (...args: any[]): void => {
    if (isDevelopment()) {
      console.warn("[DEV]", ...args);
    }
  },

  error: (...args: any[]): void => {
    if (isDevelopment()) {
      console.error("[DEV]", ...args);
    }
  },

  group: (label: string): void => {
    if (isDevelopment()) {
      console.group(`[DEV] ${label}`);
    }
  },

  groupEnd: (): void => {
    if (isDevelopment()) {
      console.groupEnd();
    }
  },

  table: (data: any, columns?: string[]): void => {
    if (isDevelopment()) {
      console.table(data, columns);
    }
  },

  // Time tracking methods
  time: (label: string): void => {
    if (isDevelopment()) {
      console.time(`[DEV] ${label}`);
    }
  },

  timeEnd: (label: string): void => {
    if (isDevelopment()) {
      console.timeEnd(`[DEV] ${label}`);
    }
  },
};

export default devLogger;
